import i18n from './../../../shared/i18n';
import BaseModel from "../../../core/components/input-widget/BaseModel";

export default class ClsSearchModel extends BaseModel {
  comment = null;

  rules = {};

  attributeLabels = {
    comment: i18n.t('comment'),
  };


  attributePlaceholders = this.attributeLabels;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  toJSON() {
    let data = super.toJSON();

    return data;
  }

  getFilteredData() {
    let returnData = [];


    return returnData;
  }
}
